import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import i18n from 'i18next';
import axios from 'axios';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import classNames from 'classnames';
import { useAuth } from '../../_common/AuthContext';

const ForgotPwd = () => {
    const {auth, updateAuth,clearAuth} = useAuth();
    const [errorMessage, setErrorMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    const validateEmail = (email) => {
        const emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
        return emailReg.test(email);
    };

    const handleSubmit = async (e) => {
        if (e) {
            e.preventDefault();
        }
        setErrorMessage('');
        setValidationErrors({});

        if (!auth.EmailForgot) {
            setValidationErrors(prev => ({ ...prev, EmailForgot: i18n.t('auth.forgot_password_section.email_required') }));
            return;
        }

        if (!validateEmail(auth.EmailForgot)) {
            setValidationErrors(prev => ({ ...prev, EmailForgot: i18n.t('auth.forgot_password_section.invalid_email_format') }));
            return;
        }

        setIsLoading(true);

        try {
            const response = await axios.post('/BBAuthentication/ForgotPwd', auth);
            const data = response.data;
            clearAuth();
            if (data.IsSuccess){
                setIsSuccess(true);
            }else{
                setErrorMessage(data.ErrorMessage);
            }
        } catch (error) {
            setErrorMessage(error.response?.data || i18n.t('auth.forgot_password_section.an_error_occurred'));
        } finally {
            setIsLoading(false);
        }
    };

    const handleInputChange = (e, field) => {
        const value = e.target.value;
        const updatedAuth = { ...auth, [field]: value };
        updateAuth(updatedAuth);
        // Clear error when auth starts typing
        if (validationErrors[field]) {
            setValidationErrors(prev => ({ ...prev, [field]: null }));
        }
    };

    return (
        <div className="login-inner">
            <div className="body-inner">
                {!isSuccess && (
                    <form id="UserIdForm" className="login-form" onSubmit={handleSubmit}>
                        <h4 className="mb-3 font-bold">{i18n.t('auth.forgot_password_section.account_recovery')}</h4>
                        <p>{i18n.t('auth.forgot_password_section.insert_forgot_password_account')}</p>
                        <div id="validator" className="mt-2" style={{ maxHeight: '52px', overflow: 'hidden' }}>
                            {errorMessage && (
                                <Message severity="error" text={errorMessage} />
                            )}
                        </div>
                        <div>
                            <InputText id="userEmailBox" value={auth.EmailForgot || ''} onChange={(e) => handleInputChange(e, 'EmailForgot')} placeholder={i18n.t('auth.forgot_password_section.email_placeholder')} type="email" required
                                className={classNames('w-full', { 'p-invalid': !!validationErrors.EmailForgot })} autoFocus />
                            {validationErrors.EmailForgot && <small className="p-error">{validationErrors.EmailForgot}</small>}
                        </div>

                        <div className="mt-4">
                            <Button type="submit" label={i18n.t('auth.next')} className="w-full" loading={isLoading} disabled={isLoading} />
                        </div>

                        <div className="mt-4">
                            <a href='/login' className='text-primary'>
                                {i18n.t('auth.cancel')}
                            </a>
                        </div>
                    </form>
                )}
                {isSuccess && (
                    <div className="successful-form">
                        <div className='login-form'>
                            <div className="text-2xl font-bold text-center">
                                {i18n.t('auth.password_successful.recover_link_sent')}
                            </div>
                            <div className="text-center" style={{marginTop: '10px' }}>
                                {i18n.t('auth.password_successful.check_email')}
                            </div>
                            <div className="text-center" style={{marginTop: '10px' }}>
                                <a href='/login' className="text-center text-primary">{i18n.t('auth.password_successful.go_back_to_login')}</a>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ForgotPwd; 